import axios from "../lib/axios";
import { Area } from "../types/area";

export const areaService = {
  getAreas: async () => {
    const { data } = await axios.get<Area[]>("/areas", {
      params: {
        $fields: "_id,name,coordinate,code,geometry",
      },
    });
    return data;
  },

  createArea: async (area: Omit<Area, "_id">) => {
    const { data } = await axios.post<Area>("/areas", area);
    return data;
  },

  updateArea: async (code: string, area: Partial<Area>) => {
    const { data } = await axios.put<Area>(`/areas/${code}`, area);
    return data;
  },

  deleteArea: async (id: string) => {
    await axios.delete(`/areas/${id}`);
    return id;
  },
};
